import { EuiIcon } from "@elastic/eui";
import { NEGATE_FILTER, TIME_FRAMES } from "Consts";
import { FILTER_FIELDS, VIEWS_DISABLED_ROUTES } from "./TopFilterConsts";
import { getRandomString } from "utils";

export const renderFilterBadgeContent = (chip: any) => {
  const isNegated = chip.name?.startsWith(NEGATE_FILTER);
  const actualValue = isNegated ? chip.name.split(NEGATE_FILTER)[1] : chip.name;

  const getDisplayValue = (field: any, value: any) => {
    switch (field) {
      case FILTER_FIELDS.WEEKDAY:
        return value;
      case FILTER_FIELDS.TIME_OF_DAY:
        return TIME_FRAMES.find((i) => i.id === `${value}`)?.name || value;
      default:
        return value;
    }
  };

  const displayValue = getDisplayValue(chip.field, actualValue);

  const negatedStyle = isNegated
    ? { textDecoration: "line-through", textDecorationColor: "#ff5c5c" }
    : {};

  if (chip.field === FILTER_FIELDS.TAG) {
    // Special case for tags - includes an icon
    return (
      <span style={{ display: "flex", alignItems: "center" }}>
        <EuiIcon size="s" type="tag" style={{ marginRight: "5px" }} />
        <span style={negatedStyle}>{displayValue}</span>
      </span>
    );
  } else {
    // General case for other filters
    return (
      <span>
        <b style={{ paddingRight: "4px" }}>{chip.filterName}:</b>
        <span style={negatedStyle}>{displayValue}</span>
      </span>
    );
  }
};

export const filterUniqueIds = new Array(10).fill(0).map(() => getRandomString(25));

// Place views and tags to the left of other filters
export const sortFilters = (filters: any) => {
  if (!filters) return [];
  return [...filters].sort((a, b) => {
    if (a.fdType === "resource_tags_v2") return -1;
    if (b.fdType === "resource_tags_v2") return 1;
    return 0;
  });
};

export const getEnabledViews = () => {
  return !VIEWS_DISABLED_ROUTES.some((path) => window.location.pathname.includes(path));
};
